<template>
  <div class="item card pt-5">
    <div class="content">

      <div href="#" class="flex justify-start align-center mb-3">
        <div :class="setClass" class="rounded-full wh-1-5 mr-2 flex-shrink-0 flex flex-center">
          <i class="material-icons color-white font-10">{{ this.data.categoryIcon }}</i>
        </div>
        <span class="font-8 color-grey-d1 lheight-9">{{ this.data.categoryTitle }}</span>
      </div>

      <router-link
        :to="{ name: 'keino', params: { mean_id: this.data.slug } }"
        tag="div"
        class="font-11 txt-bold break-word pointer"
      >{{ this.data.title }} <i class="material-icons link font-11 color-grey-l1" style="transform: rotate(45deg);">link</i></router-link>
      <!-- <h4 class="font-11 txt-bold break-all">{{ this.slug }}</h4> -->

      <!-- selite -->
      <div class="mt-3 mb-4">
        <div v-html="this.data.text" class="text-content-html pt-1 font-9 color-grey-d2"></div>
      </div>

      <!-- kuva(t) -->
      <div>
        <div v-for="(pair, index) in data.imgTextPairs" :key="index">
          <img v-if="pair.thumbM" :src="pair.thumbM" alt="" class="w-full pointer mt-2" @click="setPopupContent(pair.image, pair.imageText)">
          <img v-else-if="pair.image" :src="pair.image" alt="" class="w-full pointer mt-2" @click="setPopupContent(pair.image, pair.imageText)">
          <div v-if="pair.imageText" v-html="pair.imageText" class="image-text-field-in-card font-8 lheight-11 color-grey-d1 mb-2"></div>
          <!-- <div v-if="pair.imageText" class="image-text-field-in-card font-8 lheight-11 color-grey-d1 mb-2">{{pair.imageText}}</div> -->
          <!-- <p v-if="pair.imageText" class="font-8 lheight-11 color-grey-d1 mb-2">{{pair.imageText}}</p> -->
        </div>
      </div>

      <div class="h-2"></div> <!-- for visual reasons -->

    </div>

  </div>
</template>

<script>
// import db from '@/firebase/init'

export default {
  name: 'GitemExample',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
    /* slug: {
      type: Object
      // type: String
    } */
  },

  data () {
    return {
      popup: false
      // classOfMean: null
    }
  },

  methods: {
    setPopupContent (img, imgText) {
      this.$store.dispatch('setPopupContent', {
        img: img,
        imgText: imgText
      })
    }
  },

  computed: {
    setClass () {
      return ['group-' + this.data.ref]
    }
  }

  /* created () {
    db.collection('keinot').where('title', '==', this.data.topic).get().then(snapshot => {
      this.classOfMean = snapshot.docs[0].data().ref
    })
  } */
}
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";

/* i.link {
  transform: rotate(45deg);
} */
</style>
